export { GRAPH_WIDTH, GRAPH_HEIGHT } from "@corca/tiptap";

export const GRAPH_SCALE_CONTAINER_CLASS = "ggb-applet-scale-container";
